module.exports = __webpack_public_path__ + "static/img/duofanghuiyi.b2a19a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/duofanghuiyi.png
// module id = 1H7C
// module chunks = 24